/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconKering = createReactComponent("kering", "IconKering", [
  ["path", { d: "M16 15v-3.5a2.5 2.5 0 1 1 5 0v3.5m0 -2h-5", key: "svg-0" }],
  ["path", { d: "M3 9l3 6l3 -6", key: "svg-1" }],
  ["path", { d: "M9 20l6 -16", key: "svg-2" }]
]);

export { IconKering as default };
//# sourceMappingURL=IconKering.js.map
